// Dependencies
import React from 'react';
import radium from 'radium';
import Button from '../button/Button.tsx';
import { ThemeContext } from '../theme/Theme.jsx'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function ButtonEventsOverview(props) {
	const context = React.useContext(ThemeContext);
	function openEventsOverview() {
		const eventsOverviewUrl = context.themeManager.valueOrDefault(
			'shopping-cart', 'events-overview-url', null, 'https://leoticket.de');
		window.location = eventsOverviewUrl;
	}

	const style = {
		link: {
			color: context.themeManager.value('shopping-cart-action-bar', 'color', 'fg-color-text-highlight'),
			fontWeight: 600,
			cursor: 'pointer',
		},
		icon: {
			color: context.themeManager.value('shopping-cart-action-bar', 'color', 'fg-color-text-highlight'),
			marginRight: '.5em',
		},
	};

	const btnAsLink = props.btnLayout === 'link';

	return btnAsLink ? (
		<a onClick={openEventsOverview} target="_self" title={props.btnText} style={style.link}>
			<FontAwesomeIcon
				icon="angle-double-left"
				style={style.icon}
			/>
			{props.btnText}
		</a>
	) : <Button
		name={props.btnText}
		buttonText={props.btnText}
		iconName={props.iconName}
		onClick={openEventsOverview}
		btnStyle="highlight"
		buttonContainerStyle={props.buttonContainerStyle}
	/>;
}
ButtonEventsOverview.contextType = ThemeContext;

export default radium(ButtonEventsOverview);
